"use strict";
// Frozen Analytics report payload (v2, DEV-2377). Persisted on the Report document
// AND sent to the tokenised render route, which rebuilds the PDF from it — so the
// shape is shared verbatim by backend and frontend.
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapshotChartBreakdown = exports.otherLabel = exports.CHART_MAX_CATEGORIES = void 0;
// Every chart variable is capped at ten categories (DEV-2432 §1): the default
// top-N of a breakdown request, the cap the stack dimension is held to, and the
// number of colours in the categorical palette. One constant for both sides.
exports.CHART_MAX_CATEGORIES = 10;
/** The tail bucket's label — one wording for the chart, legend and tooltip. */
var otherLabel = function (count) { return "Other (".concat(count, ")"); };
exports.otherLabel = otherLabel;
/**
 * The breakdown a snapshot chart renders from. Snapshots frozen before
 * DEV-2432 carry only the flattened `rows` / `other`; they are lifted into the
 * current shape here so every consumer sees one contract.
 */
var snapshotChartBreakdown = function (chart) {
    if (chart.breakdown)
        return chart.breakdown;
    var rows = chart.rows.map(function (r) { return ({ key: r.label, label: r.label, value: r.value, meta: null, segments: r.segments }); });
    return {
        rows: rows,
        other: chart.other
            ? { key: '__other__', label: chart.other.label, value: chart.other.value, meta: null, segments: chart.other.segments, count: 0 }
            : null,
        totalCategories: rows.length
    };
};
exports.snapshotChartBreakdown = snapshotChartBreakdown;
